export default __webpack_public_path__ + "static/media/findus.8aedb11b.png";